export const FaceExcited = () => {
  return (
    <svg
      className="blob-face-excited"
      width="54"
      height="18"
      viewBox="0 0 54 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3474 11.1538C21.3474 12.3186 23.469 15.2307 27.4627 15.2307C31.6228 15.2307 33.5781 12.6099 33.5781 11.348"
        stroke="black"
        strokeWidth="4.07692"
        strokeMiterlimit="1.33344"
        strokeLinecap="round"
      />
      <path
        d="M51.9238 3L43.77 7.07692L51.9238 11.1538"
        stroke="black"
        strokeWidth="4.07692"
        strokeMiterlimit="1.33344"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00045 3L11.1543 7.07692L3.00045 11.1538"
        stroke="black"
        strokeWidth="4.07692"
        strokeMiterlimit="1.33344"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const FaceHappy = () => {
  return (
    <svg
      className="blob-face-happy"
      width="54"
      height="14"
      viewBox="0 0 54 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3803 7.19336C21.3803 8.35841 23.5023 11.271 27.4968 11.271C31.6576 11.271 33.6133 8.64968 33.6133 7.38754"
        stroke="black"
        strokeWidth="4.07768"
        strokeMiterlimit="1.33344"
        strokeLinecap="round"
      />
      <ellipse
        cx="5.47817"
        cy="5.47818"
        rx="5.47817"
        ry="5.47818"
        transform="matrix(-1 0 0 1 54 0)"
        fill="black"
      />
      <ellipse
        cx="5.47817"
        cy="5.47818"
        rx="5.47817"
        ry="5.47818"
        transform="matrix(-1 0 0 1 11.2539 -0.0012207)"
        fill="black"
      />
    </svg>
  )
}

export const FaceAww = () => {
  return (
    <svg
      className="blob-face-wow"
      width="61"
      height="46"
      viewBox="0 0 61 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="18" r="11" fill="#480B38" />
      <ellipse
        cx="47.5436"
        cy="13.841"
        rx="3.28414"
        ry="5.37373"
        transform="rotate(50.0719 47.5436 13.841)"
        fill="#FEFEFE"
      />
      <circle cx="55.5" cy="18.5" r="2.5" fill="#FEFEFE" />
      <circle cx="49.5" cy="21.5" r="1.5" fill="#FEFEFE" />
      <circle cx="11" cy="11" r="11" fill="#480B38" />
      <ellipse
        cx="8.54364"
        cy="6.84098"
        rx="3.28414"
        ry="5.37373"
        transform="rotate(50.0719 8.54364 6.84098)"
        fill="#FEFEFE"
      />
      <circle cx="16.5" cy="11.5" r="2.5" fill="#FEFEFE" />
      <circle cx="10.5" cy="14.5" r="1.5" fill="#FEFEFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5164 26.9029C16.3892 27.455 16.284 28.0203 16.2025 28.5971C15.0889 36.4788 18.8206 43.5231 24.5376 44.3308C30.2546 45.1386 35.792 39.4041 36.9056 31.5223C36.9871 30.9455 37.0426 30.3732 37.0734 29.8075L16.5164 26.9029Z"
        fill="#480B38"
      />
    </svg>
  )
}
